import * as React from "react";
import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItem, CookingIngredient, Minus } from "../../models/menuItem";

interface Props {
  menuItem: MenuItem;
}

export const MenuItemAllergens: React.FC<Props> = ({
  menuItem,
}) => {

  const _allergenLabel = (allergenID: string) => {
    if (!!!menuItem.allergens || menuItem.allergens.length === 0) return allergenID;
    const selectedAllergen = menuItem.allergens.find((item: any) => item.id === allergenID);
    if (!!selectedAllergen) {
        return LocalizerHelper.localized(selectedAllergen);
    }
    return allergenID;
  }


  return (
    <>
      <div>
        <div className="row" style={{marginTop: 15}}>
          <div className="col-12">
            <Typography variant="h5" gutterBottom className="menu-item-sub-header"
                        align="left">{LocalizerHelper.localized('allergens')}</Typography>
          </div>
        </div>
        <div className="row" style={{marginTop: 15}}>
          <div className="col-12 text-left">
            {menuItem?.allergens?.map((item: string) => <div key={`detail-allergen-${item}`} className="allergen-container"><img
                  src={`/assets/icons/allergens/icon_allergen_${item.toLowerCase()}.png`}
                  className={'allergen-icon'} key={`allergen-icon-${item}`}/>
                  <span>{_allergenLabel(item)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
